import { Add16Regular } from "@fluentui/react-icons";

import { useGlobalContext } from "app/store/GlobalContext";
import { Button } from "components/button/Button";
import { usePermission } from "hooks/use-permissions";
import { Tooltip } from "components/tooltip/Tooltip";
import { useRequiredCustomerId } from "hooks/use-customer-id";
import { useIsMobile } from "hooks/use-is-mobile";
import InboxDropdownPanel from "views/inbox/components/Inbox/InboxSidebar/inboxDropdownPanel";
import InboxSidebarContent from "views/inbox/components/Inbox/InboxSidebar/inboxSidebarContent";
import InboxTabsPanel from "views/inbox/components/Inbox/InboxSidebar/inboxTabsPanel";
import SearchTab from "views/inbox/components/Inbox/InboxSidebar/SearchTab";
import ActiveFilters from "./inboxFilters/ActiveFilters/ActiveFilters";
import InboxFiltersActions from "./inboxFilters/InboxFiltersActions";

export default function InboxSidebar() {
  const isMobile = useIsMobile();
  const { handleNavigation } = useGlobalContext();
  const customerId = useRequiredCustomerId();
  const isInternalUser = usePermission("isInternal");

  const TOOLTIPS = {
    search: "Sök efter meddelanden",
    filter: "Filtrera meddelanden",
    create: "Skapa nytt meddelande"
  };

  return (
    <div className={`inbox-sidebar ${!isMobile && "inbox-sidebar-desktop"}`}>
      <div className="mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <h2 className="my-3 d-inline">
            <>Inkorg</>
          </h2>

          <span className="actions-bar">
            <Tooltip content={<span>{TOOLTIPS.search}</span>}>
              <SearchTab />
            </Tooltip>
            {isInternalUser && (
              <Tooltip content={<span>{TOOLTIPS.filter}</span>}>
                <InboxFiltersActions />
              </Tooltip>
            )}
            <Tooltip content={<span>{TOOLTIPS.create}</span>}>
              <Button
                size="sm"
                color="primary"
                className="btn btn-round mr-2"
                onClick={() => {
                  handleNavigation({
                    url: `/customers/${customerId}/inbox/my/new`,
                    eventTitle: "Inbox_new"
                  });
                }}
              >
                <Add16Regular />
              </Button>
            </Tooltip>
          </span>
        </div>

        <hr className="divider-small" />
      </div>
      <ActiveFilters />
      {isMobile ? <InboxDropdownPanel /> : <InboxTabsPanel />}
      <InboxSidebarContent />
    </div>
  );
}
